import React, { useEffect, useState } from "react";
import DashboardCard from "../../Components/Card/DashboardCard";
import { useSelector } from "react-redux";
import { CircularProgress, Grid, Paper } from "@mui/material";
import configServ from "../../services/config";
// icons
import PeopleIcon from "@mui/icons-material/People";
import MedicationIcon from "@mui/icons-material/Medication";
import QuizIcon from "@mui/icons-material/Quiz";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { useNavigate } from "react-router-dom";
import CheckAndReturn from "../../utility/CheckAndReturn";
import BarGraph from "./BarGraph";
import VoiceCommand from "../../Components/VoiceRecognization/VoiceCommand ";
import {
  BlockOutlined,
  HowToReg,
  ParkSharp,
  Pending,
} from "@mui/icons-material";

//FUNCTION
function Dashboard() {
  //#region code
  const { user_id, company_id } = useSelector((state) => state.GlobalVariables);
  const navigate = useNavigate();

  const [count, setCount] = useState({});

  const fetchDashboardCount = async () => {
    try {
      const userId = user_id;
      if (userId === null) {
        navigate("/");
      }
      const dataToSend = {
        user_id: user_id,
        company_id: company_id,
      };
      const result = await configServ.getDashboardCount(dataToSend);
      setCount(result);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDashboardCount();
  }, []);

  const handleCardClick = (status) => {
    // alert(status)
    navigate("/enquiry", { state: { status } }); // status pass ho jayega
  };

  const cardData = [
    {
      title: "MEMBERS",
      number: count.customers ?? <CircularProgress />,
      icon: <PeopleIcon sx={{ color: "#fb6340" }} />,
      link: "/account-master-entry/customers",
    },

    {
      title: "APPROVED ENQUIRIES",
      number: count.approved ?? <CircularProgress />,
      icon: <HowToReg sx={{ color: "#fb6340" }} />,
      onClick: () => handleCardClick("approved"),
    },
    {
      title: "PENDING ENQUIRIES",
      number: count.pending ?? <CircularProgress />,
      icon: <Pending sx={{ color: "#fb6340" }} />,
      onClick: () => handleCardClick("pending"),
    },
    {
      title: "REJECTED ENQUIRIES",
      number: count.rejected ?? <CircularProgress />,
      icon: <BlockOutlined sx={{ color: "#fb6340" }} />,
      onClick: () => handleCardClick("rejected"),
    },
    {
      title: "TOTAL ENQUIRIES",
      number: count.enquiries_total ?? <CircularProgress />,
      icon: <ParkSharp sx={{ color: "#fb6340" }} />,
      onClick: () => handleCardClick("all"),
    },
  ];
  //#endregion

  return (
    <>
      <Grid
        container
        alignItems={"center"}
        justifyContent={"flex-start"}
        spacing={2}
        p={2}
        my={1}
        sx={{
          backgroundColor: "#000000",
          width: "100%",
        }}
      >
        {cardData.map((item, index) => (
          <DashboardCard index={index} data={item} />
        ))}
      </Grid>
      {/* <BarGraph /> */}
      {/* <VoiceCommand /> */}
    </>
  );
}

export default Dashboard;
